import Bubble from "../components/Bubble";
import LinkBubble from "../components/LinkBubble";
import { getIcon, useResponsiveView } from "../utils/fun";
import { workExperiences } from "../data/workExperiences";
import { techStacks } from "../data/techStacks";

function AboutMeSection() {
  return (
    <section className="min-vh-100 d-flex flex-column justify-content-center about-section">
      <h2 className="fw-bold fs-1 my-4">ABOUT ME</h2>
      <div className="fs-5">
        <p>
          A recent Computer Science graduate specializing in Software Engineering, Full-Stack Development, and Application Development.
        </p>
        <p>
          I also leverage Artificial Intelligence to assist in developing solutions for various real-life problems.
        </p>
      </div>
      <div className="d-flex align-items-center py-2 gap-3">
        <a 
          className="btn-bubble px-3" 
          href="/resume_marcojalenyu.pdf" 
          target="_blank" 
          rel="noopener noreferrer"
          aria-label="Open Resume"
          style={{ width: '150px' }}
        >
          <span>Resume</span>
        </a>
        <LinkBubble href="https://www.linkedin.com/in/marcojalenyu/" ariaLabel="Open LinkedIn">
          <i className="bi bi-linkedin"></i>
        </LinkBubble>
        <LinkBubble href="https://github.com/marcojalenyu" ariaLabel="Open GitHub">
          <i className="bi bi-github"></i>
        </LinkBubble>
      </div>
    </section>
  );
}

function WorkExperienceList() {
  return (
    <ul className="list-unstyled d-flex flex-wrap my-4 gap-4">
      {workExperiences.map((work, index) => (
        <li key={index}>
          <Bubble size="96px" className="mb-2">
            <img
              src={getIcon("work/" + work.logoURL)}
              alt={work.company}
              title={`${work.company}\n${work.position}\n${work.startDate} - ${work.endDate}`}
              style={{ width: '70%', height: '70%', padding: '4px' }}
            />
          </Bubble>
        </li>
      ))}
    </ul>
  );
}

function TechStackList() {
  return (
    <>
      {techStacks.map((category, index) => (
        <div key={index}>
          <h3 className="fs-4 pb-3">{category.name}</h3>
          <ul className="list-unstyled d-flex flex-wrap my-4 gap-4">
            {category.list.map((tech, index) => (
              <li key={index} className="text-center">
                <Bubble size="96px" className="mb-2 p-1">
                  <img
                    src={getIcon(category.category + "/" + tech)}
                    alt={tech}
                    title={tech}
                    style={{ size: '60%', height: '60%' }}
                  />
                </Bubble>
                <span className="fs-6">{tech}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
}

function WorkTechSection() {
  return (
    <section className="min-vh-100 d-flex flex-column justify-content-center justify-content-md-start mt-3 py-5 about-section">
      <h2 className="fw-bold pt-4 mt-5 mt-md-3">I've worked at</h2>
      <WorkExperienceList />
      <h2 className="fw-bold mb-4">What's in my tech toolbox?</h2>
      <TechStackList />
    </section>
  );
}

export default function About() {
  const mobileViewEnabled = useResponsiveView();

  return (
    (mobileViewEnabled ? (
      <div id="about" className="underwater min-vh-100 d-flex flex-column">
        <div className="container-fluid px-3">
          <AboutMeSection />
          <WorkTechSection />
        </div>
      </div>
      ) : (
        <section id="about" className="underwater min-vh-100">
          <div className="container-fluid px-3">
              <div className="row min-vh-100 px-5">
                <div className="col-12 col-md-6 d-flex pe-5">
                  <div
                    style={{
                      position: 'sticky',
                      top: '-2.5%',
                      alignSelf: 'flex-start',
                      width: '100%',
                    }}
                  >
                    <AboutMeSection />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <WorkTechSection />
                </div>
              </div>
          </div>
        </section>
      )
    )
  );
}